import styled from '@emotion/styled';

export const HomeContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #eff3f6;
`;
